import React from 'react';
import styled from 'styled-components';

import { colors } from '../../../constants';
import { Title } from '../Title';
import { Text } from '../Text';
import { InfoSection } from '../InfoSection';

interface IProps {
    className?: string;
}

const BaseSightInfoSection = ({ className }: IProps) => (
    <InfoSection
        className={className}
        bgColor={colors.greenDark}
        imageUrl="https://grandvision.s3.amazonaws.com/pnl/images/online-oogcheck/result-wistjedat.jpg"
    >
        <Title>Wist je dat?</Title>
        <Text>
            Samen met onderzoeksbureau Motivaction hebben we onderzoek gedaan
            naar het zicht van Nederlanders. Ruim een derde van de ondervraagden
            geeft aan dat ze zelf niet doorhadden dat hun zicht achteruit was
            gegaan. Het ging heel geleidelijk.
        </Text>
        <Text>
            Ook ouders herkennen de symptomen van minder goed zicht bij hun kind
            nauwelijks. Een derde van de ouders van een brildragend kind heeft
            nooit gemerkt dat hun kind last had van slecht zicht. De meest
            bekende klachten zijn: hoofdpijn, vermoeidheid en leesproblemen,
            maar ook concentratieproblemen.
        </Text>
        <Text>
            Ook gaan we vaak wel twee keer per jaar naar de tandarts, maar
            vergeten we ons meest belangrijke en meest kostbare orgaan: onze
            ogen. Laat je ogen dus jaarlijks controleren door een vakkundige
            (oog)arts, opticien of optometrist.
        </Text>
    </InfoSection>
);

export const SightInfoSection = styled(BaseSightInfoSection)`
    ${Title} {
        margin-bottom: 40px;
    }

    ${Text} {
        margin: 20px 0;
    }
`;
